var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var usePlanData = function (setDataFormBusiness) {
    var plan = useState(findParamInLocalStorage("Plan"))[0];
    var productCode = useState(findParamInLocalStorage("productCode", "steps"))[0];
    var _a = useState(false), isCommerce = _a[0], setIsCommerce = _a[1];
    var _b = useState(""), planCode = _b[0], setPlanCode = _b[1];
    useEffect(function () {
        var _a;
        if (plan) {
            var isCommerceValue_1 = plan.name.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
            setPlanCode((_a = plan.code) !== null && _a !== void 0 ? _a : "");
        }
    }, [plan]);
    return {
        plan: plan,
        productCode: productCode,
        isCommerce: isCommerce,
        planCode: planCode,
    };
};
